import styled from "styled-components"

const Credits = styled.span`
  background-color: #fff;
  color: ${props => props.theme.colors.lightgrey};
  display: block;
  font-size: 10px;
  margin: 0;
  padding: 2px 5px;
  position: absolute;
  right: 2px;
  top: 2px;
  z-index: 5;

  @media only screen and (min-width: ${props => props.theme.mq.small}) {
    font-size: 11px;
    padding: 3px 7px;
  }
`

const Caption = styled.small`
  color: ${props => props.theme.colors.lightgrey};
  display: block;
  font-size: 11px;
  margin-top: 10px;
  text-align: center;

  @media only screen and (min-width: ${props => props.theme.mq.small}) {
    font-size: 12px;
    margin-top: 20px;
  }
`

export const Pic = {
  Credits,
  Caption,
}
